import React, { useState } from "react";
import { useForm } from "react-hook-form";
import useLogin from "../../API/useLogin";
import LoadingComponent from "../../Components/LoadingComponent/LoadingComponent";
import LoginPageStyles from "./LoginStyles";

import {
  Grid,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
  Container,
  Box,
  IconButton,
  InputAdornment,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export default function Login({ toggleTheme, theme }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [showPassword, setShowPassword] = useState(false);

  const { login, loading, error } = useLogin();
  const onLoginSubmit = (data) => {
    login(data);
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <LoginPageStyles theme={theme}>
      <Container maxWidth="md" className="container">
        <Grid container spacing={0} className="gridContainer">
          <Grid item xs={12} sm={6} className="leftSection">
            <Box className="headerBox">
              <Typography variant="h2" className="portalTitle">
                Manager Portal
              </Typography>
              <Typography variant="h4" className="companyName">
                ZAD Technologies
              </Typography>
            </Box>
            <IconButton
              className="themeToggle"
              onClick={toggleTheme}
            ></IconButton>
          </Grid>
          <Grid item xs={12} sm={6} className="rightSection">
            <Card className="formCard">
              <CardContent>
                <Typography
                  variant="h4"
                  fontWeight="bold"
                  textAlign="center"
                  gutterBottom
                >
                  Login
                </Typography>
                <form onSubmit={handleSubmit(onLoginSubmit)}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Email"
                        variant="outlined"
                        margin="normal"
                        {...register("email", {
                          required: "Email is required",
                        })}
                        error={!!errors.email}
                        helperText={errors.email?.message}
                        className="textField"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        label="Password"
                        variant="outlined"
                        type={showPassword ? "text" : "password"}
                        margin="normal"
                        {...register("password", {
                          required: "Password is required",
                        })}
                        error={!!errors.password}
                        helperText={errors.password?.message}
                        className="textField"
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                onClick={togglePasswordVisibility}
                                edge="end"
                              >
                                {showPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                    {error && (
                      <Grid item xs={12}>
                        <Typography variant="body2" color="error">
                          Wrong username or password
                        </Typography>
                      </Grid>
                    )}
                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        color="success"
                        className="loginButton"
                      >
                        {!loading ? (
                          "Login"
                        ) : (
                          <LoadingComponent size="2em" thickness={5} />
                        )}
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </LoginPageStyles>
  );
}
